module.exports = __webpack_public_path__ + "static/media/WhoAreWe1.a57c3e7c.svg";